import { StubErrorBoundary, StubPage } from '#app/components/stub-page.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Frisbeegolfradan rakentaminen — Frisbeegolfradat' },
]

export default function Index() {
	return (
		<StubPage
			eyebrow="Radat"
			title="Frisbeegolfradan rakentaminen"
			intro="Vinkit ja ohjeet uuden radan suunnitteluun, rakentamiseen ja ylläpitoon."
		/>
	)
}

export { StubErrorBoundary as ErrorBoundary }
